<template>
  <div>
    <div class="app-banner">
      <transition
        name="fade"
        enter-active-class="animate__animated animate__fadeIn"
        leave-active-class="animate__animated animate__fadeOut"
      >
        <div class="app-banner-box">
          <img
            src="@/assets/img/banner_02.png"
            alt=""
            class="app-banner-box-img"
          />
        </div>
      </transition>
      <transition
        name="slide"
        enter-active-class="animate__animated animate__slideInDown"
        leave-active-class="animate__animated animate__slideOutUp"
      >
        <div class="banner-content">
          <div class="block">
            <h2>专业上门按摩服务<br />足不出户享受健康</h2>
            <p class="block-text">
              <span class="block-item">
                国家认证技师 | 30分钟极速预约 | 服务覆盖N+城市
              </span>
            </p>
            <div class="features">
              <div class="feature">
                <i class="iconfont icon-shenfenrenzheng"></i>
                <span>国家认证技师</span>
              </div>
              <div class="feature">
                <i class="iconfont icon-shizhong"></i>
                <span>30分钟极速预约</span>
              </div>
              <div class="feature">
                <i class="iconfont icon-dingweiweizhi2"></i>
                <span>服务覆盖N+城市</span>
              </div>
            </div>
            <!-- <p class="block-text">
            <span class="block-item"
              >东莞市怡福健康管理有限公司，正式成立于2022年。是一家以“O2O‘三体 ’架构：线上+线下+CRM 的发展战略互联网电商服务公司。</span
            >
          </p> -->
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {
      name: "轮播图",
    };
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.app-banner {
  width: 100%;
  height: auto;
  position: relative;
  background-color: #f1f0ec;

  .app-banner-box {
    position: relative; /* 关键：建立定位上下文 */

    .app-banner-box-img {
      width: 100%;
      max-width: 1200px;
      display: block; /* 消除图片底部空隙 */
      margin: 0 auto;
    }

    /* 创建遮罩层 - 添加到父容器 */
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.4);
      pointer-events: none; /* 确保遮罩层不会阻挡交互 */
    }
  }

  .banner-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 20;
    // background-color: rgba(26, 158, 101, 0.6);
    color: #fff;
    padding: 0.3rem 0.5rem;
    width: 100%;

    .block {
      width: 100%;
      margin: 0 auto;
      text-align: center;
    }

    h2 {
      font-size: 0.7rem;
      margin-bottom: 0.3162rem;
      font-weight: 700;
      line-height: 1.2;
    }

    .block-text {
      font-size: 0.3rem;
    }

    .features {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      gap: .6324rem;
      margin-top: .4743rem;
      font-size: .3162rem;

      .feature {
        width: 3.6364rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(10px);
        padding: .2372rem .3953rem;
        border-radius: 50px;
      }

      .feature i {
        margin-right: 3px;
        font-size: .3953rem;
      }
    }
  }
}

@media (max-width: 810px) {
  .features {
    flex-direction: column;
    justify-content: space-around;
    gap: .2372rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Banner.vue